import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { oidcService } from '../../services/oidcService';
import { useAuthSession } from '../hooks/useAuthSession';

const RequireAuth: React.FC = () => {
  const { status } = useAuthSession();
  const location = useLocation();

  useEffect(() => {
    if (status === 'unauthenticated' || status === 'reauth_required') {
      void oidcService.login(location.pathname);
    }
  }, [status, location.pathname]);

  switch (status) {
    case 'restoring':
    case 'authenticating':
    case 'refreshing':
    case 'unauthenticated':
    case 'reauth_required':
      return (
        <div className="flex items-center justify-center min-h-screen">
          Loading...
        </div>
      );

    case 'workspace_selecting':
      return <Navigate to="/auth/workspace-select" replace />;

    case 'authenticated':
      return <Outlet />;

    default:
      return null;
  }
};

export default RequireAuth;
